import { capitalize } from "./textFunctions";

export default data =>
  data.coding[0].display
    ? capitalize(data.coding[0].display)
    : data.coding[0].code;
